import React from 'react';

const inputStyle = {
  background: 'var(--bg-input)',
  border: '1px solid var(--border-accent)',
  color: 'var(--text-primary)',
  outline: 'none',
};

/**
 * NewSpeakerFields — inline name/email capture for a speaker who isn't a club
 * member yet. Submitting the parent form creates a provisional member row and
 * sends them an invitation.
 *
 * Fields are prefilled from whatever the admin already typed into the picker,
 * which is what keeps this frictionless — they usually only fill one more box.
 *
 * Props:
 *   value    — { email, first_name, last_name }
 *   onChange — (next) => void
 *   onCancel — () => void, switches back to picking an existing member
 */
export default function NewSpeakerFields({ value, onChange, onCancel }) {
  const set = (key) => (e) => onChange({ ...value, [key]: e.target.value });

  return (
    <div
      className="rounded-xl p-3 space-y-3"
      style={{ background: 'var(--accent-dim)', border: '1px solid var(--border-accent)' }}
    >
      <div className="flex items-center justify-between gap-2">
        <p className="text-xs font-semibold" style={{ color: 'var(--accent)' }}>
          New speaker — we'll invite them to the club
        </p>
        <button
          type="button"
          onClick={onCancel}
          className="text-xs font-medium"
          style={{ color: 'var(--text-muted)', background: 'none', border: 'none', cursor: 'pointer' }}
        >
          ← pick an existing member
        </button>
      </div>

      <div>
        <label htmlFor="new-speaker-email" className="block text-xs font-medium mb-1" style={{ color: 'var(--text-muted)' }}>
          Email <span style={{ color: 'var(--accent)' }}>*</span>
        </label>
        <input
          id="new-speaker-email"
          type="email"
          required
          value={value.email}
          onChange={set('email')}
          placeholder="speaker@example.com"
          className="w-full px-3 py-2 rounded-lg text-sm"
          style={inputStyle}
        />
      </div>

      <div className="grid grid-cols-2 gap-2">
        <div>
          <label htmlFor="new-speaker-first" className="block text-xs font-medium mb-1" style={{ color: 'var(--text-muted)' }}>
            First name <span style={{ color: 'var(--accent)' }}>*</span>
          </label>
          <input
            id="new-speaker-first"
            type="text"
            required
            maxLength={100}
            value={value.first_name}
            onChange={set('first_name')}
            className="w-full px-3 py-2 rounded-lg text-sm"
            style={inputStyle}
          />
        </div>
        <div>
          <label htmlFor="new-speaker-last" className="block text-xs font-medium mb-1" style={{ color: 'var(--text-muted)' }}>
            Last name
          </label>
          <input
            id="new-speaker-last"
            type="text"
            maxLength={100}
            value={value.last_name}
            onChange={set('last_name')}
            className="w-full px-3 py-2 rounded-lg text-sm"
            style={inputStyle}
          />
        </div>
      </div>
    </div>
  );
}
